import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getAKWAnalyticsReportDataStart,
  getAKWAnalyticsReportDataSuccess,
  getAKWAnalyticsReportDataFailed,
  getAKWAnalyticsWeeklyReportDataStart,
  getAKWAnalyticsWeeklyReportDataSuccess,
  getAKWAnalyticsWeeklyReportDataFailed
} from 'redux/actions/aestheticKpiWarehouse';


const aestheticKpiWarehouseApi = `${shopManagerApi}/aesthetic-kpi-warehouse`;

//AKW - Aesthetic KPI Warehouse
export const getAKWAnalyticsReportDataApi = async ({
  dispatch,
  filters
}) => {
  try {
    const filterParams = new URLSearchParams(filters).toString();
    dispatch(getAKWAnalyticsReportDataStart());
    const { data } = await api.get(`${aestheticKpiWarehouseApi}/v1/report/sales-monthly?${filterParams}`);
    dispatch(getAKWAnalyticsReportDataSuccess(data));
  } catch (e) {
    dispatch(getAKWAnalyticsReportDataFailed(e));
  }
};

export const getAKWAnalyticsWeeklyReportDataApi = async ({
  dispatch,
  filters
}) => {
  try {
    const filterParams = new URLSearchParams(filters).toString();
    dispatch(getAKWAnalyticsWeeklyReportDataStart());
    const { data } = await api.get(`${aestheticKpiWarehouseApi}/v1/report/sales-weekly?${filterParams}`);
    dispatch(getAKWAnalyticsWeeklyReportDataSuccess(data));
  } catch (e) {
    dispatch(getAKWAnalyticsWeeklyReportDataFailed(e));
  }
};
